exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".Filters__filters--f172c4 {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n\n.Filters__select--60bbec {\n  margin-bottom: 16px;\n}\n\n@media (min-width: 800px) {\n  .Filters__filters--f172c4 {\n    -ms-flex-direction: row;\n        flex-direction: row;\n  }\n\n  .Filters__select--60bbec {\n    margin-right: 20px;\n  }\n\n  .Filters__select--60bbec {\n    width: 280px;\n    margin-bottom: 0;\n  }\n}\n", ""]);

// exports
exports.locals = {
	"filters": "Filters__filters--f172c4",
	"select": "Filters__select--60bbec"
};


//////////////////
// WEBPACK FOOTER
// /tw-build/dev/global-site/~/css-loader?{"modules":true,"localIdentName":"[name]__[local]--[hash:6]"}!/tw-build/dev/global-site/~/postcss-loader!./component/CurrentOpenings/Filters.css
// module id = 104
// module chunks = 0